import { makeStyles } from '@material-ui/core/styles';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { LegislationArticleAPI } from '../../../API/legislation_article';
import MySelect from '../MySelect';
import MyDivider from '../MyDivider';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import UnoButton from '../UnoButton';
import { Grid, IconButton, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({

    root: {
        '& .articleNode': {

            border: "solid 2px #ccc",
            borderRadius: "10px",
            marginBottom: "8px",
            padding: "12px",
            position: "relative",

            '& .articleTop': {
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: "8px",
                minHeight: "36px",
            },

            '& .articleInfos': {
                display: "flex",
                alignItems: "center",
                gap: "16px"
            },

            '& .confirmRemoveOverlay': {
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",

                '& .theOverlay': {
                    background: "white",
                    opacity: 0.9,
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    borderRadius: "10px",
                },

                '& .theActions': {
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    gap: "8px",
                    justifyContent: 'center',
                }

            },

            '& .Mui-error': {
                marginTop: '4px',
                marginLeft: '0px',
                fontSize: '0.75rem',
                textAlign: 'left',
                fontWeight: '400',
                lineHeight: '1.66',
                color: '#f44336',
            },

        },

        '& .articleNode.articleNodeError': {
            border: "solid 2px #f44336",
        }
    },

}));

export default function GroupArticlesWrapper(props) {

    const classes = useStyles();

    const {
        initialArticles,
        articlesNodesCallback,
        submitted,
        validatedMessages,
    } = props

    const [loadedArticles, setLoadedArticles] = useState([]);

    const [allResolutions, setAllResolutions] = useState([]);
    const [allSegments, setAllSegments] = useState([]);
    const [allArticles, setAllArticles] = useState([]);

    const initializedRef = useRef(false);

    const blankNode = () => ({
        fund_group_id: null,
        article_id: null,
        resolution_id: null,
        segment_id: null,
    });

    const updateArticleNode = (index, changes) => {

        const currentArticlesNodes = [...loadedArticles];
        currentArticlesNodes[index] = {
            ...currentArticlesNodes[index],
            ...changes,
        }
        setLoadedArticles(currentArticlesNodes);
    }

    const getArticleNode = useCallback((index, article, notEnableDelete) => {

        const { article_id, resolution_id, segment_id, confirmDelete } = article;

        const selectResolutionsOptions = allResolutions.map(el => ({
            id: el.id, name: el.resolution_name
        }));
        const selectSegmentsOptions = allSegments.filter(el => el.resolution_version_id == resolution_id).map(el => ({
            id: el.id, name: el.description
        }));
        const selectArticlesOptions = allArticles.filter(el => el.legislation_segment_id == segment_id).map(el => ({
            id: el.id, name: el.device
        }));

        const isErrorMode = validatedMessages[index]?.length;

        return <div className={`articleNode ${isErrorMode ? 'articleNodeError' : ''}`}>
            <div className='articleTop'>
                {
                    segment_id &&
                    <UnoButton
                        size="verySmall"
                        type="primaryClean"
                        onClick={() => addAllArticlesFromSegment(index)}>
                        {'Adicionar todos os artigos do segmento'}
                    </UnoButton>
                }
                {
                    !notEnableDelete &&
                    <IconButton size="small" onClick={() => updateArticleNode(index, { confirmDelete: true })}>
                        <DeleteIcon />
                    </IconButton>
                }
            </div>
            <div className='articleInfos'>

                <Grid container spacing={1}>
                    <Grid item md={3} lg={3} xl={3} xs={12} sm={12}>
                        <MySelect
                            customWidth={"100%"}
                            initblank
                            outerlabel={'Resolução'}
                            value={resolution_id}
                            onChange={(e) => updateArticleNode(index, {
                                resolution_id: e.target.value,
                                segment_id: null,
                                article_id: null,
                            })}
                            options={selectResolutionsOptions.map((row) => (
                                <option key={'resolution-options' + row.id} value={row.id}>{row.name}</option>
                            ))}
                            helperText={"Resolução"}
                        />
                    </Grid>

                    <Grid item md={4} lg={4} xl={4} xs={12} sm={12}>
                        <MySelect
                            customWidth="100%"
                            initblank
                            outerlabel={'Seg. da legislação'}
                            disabled={!resolution_id}
                            value={segment_id}
                            onChange={(e) => updateArticleNode(index, {
                                segment_id: e.target.value,
                                article_id: null,
                            })}
                            options={selectSegmentsOptions.map((row) => (
                                <option key={'segment-select-group-article' + row.id} value={row.id}>{row.name}</option>
                            ))}
                            helperText={"Segmento"}
                        />
                    </Grid>

                    <Grid item md={5} lg={5} xl={5} xs={12} sm={12}>
                        <MySelect
                            customWidth="100%"
                            initblank
                            outerlabel={'Art. de resolução'}
                            value={article_id}
                            disabled={!segment_id}
                            onChange={(e) => updateArticleNode(index, { article_id: e.target.value })}
                            options={selectArticlesOptions.map((row) => (
                                <option key={'article-select-group-article' + row.id} value={row.id}>{row.name}</option>
                            ))}
                            helperText={"Artigo"}
                        />
                    </Grid>
                </Grid>

            </div>
            {
                confirmDelete &&
                <div className={"confirmRemoveOverlay"} style={{ display: "flex", alignItems: 'center' }}>
                    <div className='theOverlay'></div>
                    <div className='theActions'>
                        <Typography> Tem certeza que deseja remover o artigo?</Typography>
                        <div style={{ display: 'flex', alignItems: "center", justifyContent: 'center', gap: "8px" }}>
                            <UnoButton
                                size="verySmall"
                                type={'primary'}
                                onClick={() => removeNode(index)}>
                                {'Sim'}
                            </UnoButton>
                            <UnoButton
                                size="verySmall"
                                color="secondary"
                                onClick={() => updateArticleNode(index, { confirmDelete: false })}>
                                {'Cancelar'}
                            </UnoButton>
                        </div>
                    </div>

                </div>
            }

            {
                submitted &&
                validatedMessages[index] &&
                <div>
                    {validatedMessages[index].map((el, i) => (<div key={'msg-' + index + '-' + i} className='Mui-error'>{el}</div>))}
                </div>
            }

        </div>

    }, [
        loadedArticles,
        allResolutions,
        allSegments,
        allArticles,
        submitted,
        validatedMessages
    ]);

    const articles = useMemo(() => {
        const loadedArticlesSize = loadedArticles.length;
        return loadedArticles.map((el, index) => getArticleNode(index, el, loadedArticlesSize == 1 && index == 0));

    }, [loadedArticles, submitted, validatedMessages, allResolutions, allSegments, allArticles]);

    const addNode = () => {
        setLoadedArticles([...loadedArticles, blankNode()]);
    }

    //Insere todos os artigos do segmento do nó informado, pulando os que já estão no agrupamento.
    const addAllArticlesFromSegment = (index) => {

        const node = loadedArticles[index];
        if (!node || !node.segment_id) return;

        const segmentArticles = allArticles.filter(el => el.legislation_segment_id == node.segment_id);
        if (!segmentArticles.length) return;

        const current = [...loadedArticles];
        const existingIds = new Set(current.filter(a => a.article_id).map(a => String(a.article_id)));

        const toAdd = segmentArticles.filter(a => !existingIds.has(String(a.id)));
        if (!toAdd.length) return;

        let startIdx = 0;
        //Se o nó atual ainda não tem artigo, aproveita-o para o primeiro
        if (!node.article_id) {
            current[index] = { ...node, article_id: toAdd[0].id };
            startIdx = 1;
        }

        for (let i = startIdx; i < toAdd.length; i++) {
            current.push({
                fund_group_id: node.fund_group_id != null ? node.fund_group_id : null,
                resolution_id: node.resolution_id,
                segment_id: node.segment_id,
                article_id: toAdd[i].id,
            });
        }

        setLoadedArticles(current);
    }

    const removeNode = (index) => {
        const current = [...loadedArticles]
        current.splice(index, 1);
        setLoadedArticles(current);
    }

    const preLoad = async () => {

        const reslutionsVersions = await LegislationArticleAPI.getResolutionVersions()
        const legislationSegments = await LegislationArticleAPI.listLegislationSegments();
        const legislationArticles = await LegislationArticleAPI.listAllLegislationArticles();

        if (reslutionsVersions.success
            && legislationSegments.success
            && legislationArticles.success) {

            setAllResolutions(reslutionsVersions.body.rows);
            setAllSegments(legislationSegments.body.rows);
            setAllArticles(legislationArticles.body.rows);

        }
    }

    //Inicializa a lista de nós a partir de initialArticles (edição) ou com um nó em branco (criação).
    //Roda apenas uma vez, quando initialArticles vira um array (para não sobrescrever a edição do usuário).
    useEffect(() => {

        if (initializedRef.current) return;
        if (!Array.isArray(initialArticles)) return;

        initializedRef.current = true;

        if (initialArticles.length) {
            setLoadedArticles(initialArticles.map(a => ({
                id: a.id,
                fund_group_id: a.fund_group_id,
                article_id: a.article_id,
                resolution_id: a.resolution_id,
                segment_id: a.segment_id,
            })));
        } else {
            setLoadedArticles([blankNode()]);
        }

    }, [initialArticles])

    useEffect(() => {
        articlesNodesCallback(loadedArticles)
    }, [loadedArticles])

    useEffect(() => {
        preLoad();
    }, [])

    return (

        <div className={classes.root}>
            <MyDivider title={"Artigos do agrupamento"} />
            {articles}
            <UnoButton
                type={'primary'}
                startIcon={<AddIcon />}
                float={'right'}
                onClick={() => addNode()}>
                {'Adicionar artigo'}
            </UnoButton>
        </div>
    );
}
